<template>
  <div v-if="hasIssued" class="download_all_voucher">
    <div id="download_voucher" class="download_voucher">
      <!--Taxi transfer voucher-->
      <div v-if="hasIssued.taxi && taxi && lang[4]" class="block-item">
        <div class="container">
          <h3 class="title" style="font-size: 16pt; padding: 10pt 0">{{ lang[4].SFS_LANG_ROW_1 }}</h3>
        </div>
      </div>
      <div v-if="hasIssued.taxi && taxi && lang[4]">
        <div v-if="airline && airline.params && airline.params.enable_ovb_vcn > 0" class="container">
          <div
            style="margin: 14pt 0"
            v-html="
              replaceStr(lang[4].SFS_LANG_ROW_2, ['<airport_name>', '<airport_name>'], [taxi.dairport_name, taxi.dairport_name])
            "
          ></div>
          <CreditCard />
        </div>
        <div class="container" v-html="replaceStr(lang[4].SFS_LANG_ROW_3, ['<airline_name>'], [airline.name])"></div>
        <div v-if="taxi" class="container">
          <h2 class="title" style="margin-bottom: 0.5rem; line-height: 1.2; font-size: 18pt">
            {{ lang[4].SFS_LANG_ROW_4 }}
          </h2>
          <p style="margin: 0px">
            {{ lang[4].SFS_LANG_ROW_5 }}
            <span>: {{ taxi.address }}</span>
          </p>
          <p style="margin: 0px">
            {{ lang[4].SFS_LANG_ROW_6 }}
            <span>: {{ taxi.name }}</span>
          </p>
          <p style="margin: 0px">
            {{ lang[4].SFS_LANG_ROW_7 }}
            <span>: {{ taxi.telephone }}</span>
          </p>
        </div>
      </div>
      <!--Taxi transfer voucher-->

      <!--Refreshment voucher-->
      <div v-if="hasIssued.refreshment && Refreshment && lang[2]" class="block-item">
        <div class="container">
          <h3 class="title" style="font-size: 16pt; padding: 10pt 0">{{ lang[2].SFS_LANG_ROW_8 }}</h3>
        </div>
      </div>
      <div v-if="hasIssued.refreshment && Refreshment && lang[2]" class="container">
        <div class="voucher">
          <p>{{ lang[2].SFS_LANG_ROW_3 }}</p>
          <p
            v-html="
              replaceStr(lang[2].SFS_LANG_ROW_4, ['<amount>', '<currency>'], [Refreshment.price_per_person, Refreshment.currency])
            "
          ></p>
          <CreditCard :amount="Refreshment.price_per_person" />
          <p>{{ lang[2].SFS_LANG_ROW_5 }}</p>
          <p>{{ lang[2].SFS_LANG_ROW_6 }}</p>
          <p>{{ lang[2].SFS_LANG_ROW_7 }}</p>
        </div>
      </div>
      <!--Refreshment voucher-->

      <!--Hotel voucher-->
      <div v-if="hasIssued.hotel && PaxsHotel" class="block-item">
        <div class="container">
          <h3 class="title" style="font-size: 16pt; padding: 10pt 0">HOTEL VOUCHER</h3>
        </div>
      </div>

      <div v-if="hasIssued.hotel && PaxsHotel && lang['hotel_mobile_new']" class="container">
        <div v-if="PaxsHotel.length">
          <div v-for="(paxHotel, key) in PaxsHotel" :key="key" class="voucher">
            <div class="text-center">
              <img v-if="paxHotel.img1 !== ''" :src="paxHotel.img1" style="max-width: 690px" />
              <img v-else-if="paxHotel.img2 !== ''" :src="paxHotel.img2" style="max-width: 690px" />
              <img v-else-if="paxHotel.img3 !== ''" :src="paxHotel.img3" style="max-width: 690px" />
            </div>
            <div v-if="airline && airline.template_config && airline.template_config.logo_coupon">
              <img style="width: 60px" class="mr-4" :src="airline.template_config.logo_coupon" />
              <h2 class="title d-inline-block">{{ paxHotel.name }}</h2>
            </div>
            <h2 v-else class="title sb_mobile sb_coupon" style="padding-left: 45pt; width: 100%">{{ paxHotel.name }}</h2>
            <div class="hotel-info">
              <span>for: </span>
              <span>{{ paxHotel.title }}&nbsp;{{ paxHotel.first_name }}&nbsp;{{ paxHotel.last_name }}</span>
              <div v-for="(paxGroup, index) in paxHotel.group_passengers" :key="index" style="color: #7f7f7f; text-indent: 35px">
                {{ paxGroup.title + ' ' + paxGroup.first_name + ' ' + paxGroup.last_name }}
              </div>
            </div>
            <div class="voucher-info">
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_2 }}: <span>{{ paxHotel.name }}</span
              ><br />
              <span>{{ paxHotel.address }}</span
              ><br />
              <span>Tel: {{ paxHotel.telephone }}</span
              ><br />
              <span v-if="paxHotel.web_address"
                ><strong>{{ paxHotel.web_address }}</strong></span
              >
            </div>
            <div v-if="PaxsHotel.id_other_service && Number(PaxsHotel.id_other_service.freewifi) === 2" class="voucher-info">
              <strong>
                <span v-html="replaceStr(lang['hotel_mobile_new'].SFS_LANG_ROW_37, ['<services>'], '')"></span><br />
                <span>- Payed Wi-Fi</span>
              </strong>
            </div>
            <div class="voucher-info">
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_38 || 'Valid for' }}:
              <span
                v-if="paxHotel.group_passengers"
                v-html="
                  replaceStr(
                    lang['hotel_mobile_new'].SFS_LANG_ROW_39,
                    ['<number_person>'],
                    [paxHotel.group_passengers.length + 1]
                  )
                "
              ></span
              ><br />
              <span
                v-if="paxHotel.room_type"
                v-html="
                  replaceStr(
                    lang['hotel_mobile_new'].SFS_LANG_ROW_40,
                    ['<room_type>'],
                    [roomType[paxHotel.room_type] ? roomType[paxHotel.room_type] : 'other']
                  )
                "
              ></span>
            </div>
            <div v-if="paxHotel.mealplan_desc">- {{ paxHotel.mealplan_desc }}</div>
            <div v-else class="voucher-info">
              <span v-if="Number(paxHotel.price_breakfast) && Number(paxHotel.hasBreakfast)">
                <span v-if="Number(paxHotel.bf_service_hour) === 1">
                  {{ lang['hotel_mobile_new'].SFS_LANG_ROW_63 }}
                </span>
                <span
                  v-else-if="Number(paxHotel.bf_service_hour) === 2"
                  v-html="
                    replaceStr(
                      lang['hotel_mobile_new'].SFS_LANG_ROW_46,
                      ['<breakfast_open_time>', '<breakfast_close_time>'],
                      [paxHotel.bf_opentime, paxHotel.bf_closetime]
                    )
                  "
                >
                </span>
                <br />
              </span>
              <span v-if="Number(paxHotel.price_lunch) && Number(paxHotel.hasLunch)">
                <span v-if="Number(paxHotel.lunch_service_hour) === 1">
                  {{ lang['hotel_mobile_new'].SFS_LANG_ROW_64 }}
                </span>
                <span
                  v-else-if="Number(paxHotel.lunch_service_hour) === 2"
                  v-html="
                    replaceStr(
                      lang['hotel_mobile_new'].SFS_LANG_ROW_48,
                      ['<lunch_open_time>', '<lunch_close_time>'],
                      [paxHotel.lunch_opentime, paxHotel.lunch_closetime]
                    )
                  "
                >
                </span>
                <br />
              </span>
              <span v-if="Number(paxHotel.price_mealplan) && Number(paxHotel.hasDinner)">
                <span v-if="Number(paxHotel.stop_selling_time) === 24">
                  {{ lang['hotel_mobile_new'].SFS_LANG_ROW_50 }}
                </span>
                <span v-else-if="paxHotel.stop_selling_time">
                  {{ lang['hotel_mobile_new'].SFS_LANG_ROW_65 }} {{ paxHotel.stop_selling_time }}
                </span>
                <br />
              </span>
            </div>
            <p
              v-html="
                replaceStr(
                  lang['hotel_mobile_new'].SFS_LANG_ROW_41,
                  ['<start_date>', '<end_date>'],
                  [moment(pax.flight_date).format('DD'), moment(moment(paxHotel.blockdate)).add(1, 'd').format('DD-MM-YYYY')]
                )
              "
            ></p>
            <p v-if="paxHotel.comment !== ''">
              <strong> {{ lang['hotel_mobile_new'].SFS_LANG_ROW_54 }}: </strong>
              <span class="hotel-comment" v-html="linkify(PaxsHotel.comment)"></span>
            </p>
            <p>
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_7 }}:
              <strong>{{ paxHotel.code }}</strong>
            </p>
            <h2 class="billing-title">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_57 }}:</h2>
            <div class="voucher-info">
              <p>
                {{ lang['hotel_mobile_new'].SFS_LANG_ROW_58 }}:
                <span>{{ pax.flight_number }}</span>
              </p>
              <p>
                {{ lang['hotel_mobile_new'].SFS_LANG_ROW_59 }}:
                <span>{{ moment(pax.flight_date).format('DD-MMM-YYYY') }}</span>
              </p>
              <p>
                {{ lang['hotel_mobile_new'].SFS_LANG_ROW_8 }}:
                <span>{{ paxHotel.blockcode }}</span>
              </p>
              <p>
                {{ lang['hotel_mobile_new'].SFS_LANG_ROW_7 }}:
                <span>{{ paxHotel.code }}</span>
              </p>
              <p
                v-if="paxHotel.group_passengers"
                v-html="
                  replaceStr(
                    lang['hotel_mobile_new'].SFS_LANG_ROW_60,
                    ['<number_person>'],
                    [paxHotel.group_passengers.length + 1]
                  )
                "
              ></p>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="voucher">
            <div class="text-center">
              <img v-if="PaxsHotel.img1 !== ''" :src="PaxsHotel.img1" style="max-width: 690px" />
              <img v-else-if="PaxsHotel.img2 !== ''" :src="PaxsHotel.img2" style="max-width: 690px" />
              <img v-else-if="PaxsHotel.img3 !== ''" :src="PaxsHotel.img3" style="max-width: 690px" />
            </div>
            <div v-if="airline && airline.template_config && airline.template_config.logo_coupon">
              <img style="width: 60px" class="mr-4" :src="airline.template_config.logo_coupon" />
              <h2 class="title d-inline-block">{{ PaxsHotel.name }}</h2>
            </div>
            <h2
              v-else
              class="title sb_mobile sb_coupon"
              :style="{
                'padding-inline': '45pt',
                width: '100%',
                'background-position-x': this.direction == 'rtl' ? 'right' : 'left'
              }"
            >
              {{ PaxsHotel.name }}
            </h2>
            <div class="hotel-info">
              <span>for: </span>
              <span>{{ PaxsHotel.title }}&nbsp;{{ PaxsHotel.first_name }}&nbsp;{{ PaxsHotel.last_name }}</span>
              <div v-for="(paxGroup, index) in PaxsHotel.group_passengers" :key="index" style="color: #7f7f7f; text-indent: 35px">
                {{ paxGroup.title + ' ' + paxGroup.first_name + ' ' + paxGroup.last_name }}
              </div>
            </div>
            <div class="voucher-info">
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_2 }}: <span>{{ PaxsHotel.name }}</span
              ><br />
              <span>{{ PaxsHotel.address }}</span
              ><br />
              <span>Tel: {{ PaxsHotel.telephone }}</span
              ><br />
              <span v-if="PaxsHotel.web_address"
                ><strong>{{ PaxsHotel.web_address }}</strong></span
              >
            </div>
            <div v-if="PaxsHotel.id_other_service && Number(PaxsHotel.id_other_service.freewifi) === 2" class="voucher-info">
              <strong>
                <span v-html="replaceStr(lang['hotel_mobile_new'].SFS_LANG_ROW_37, ['<services>'], '')"></span><br />
                <span
                  >- WiFi costs: {{ PaxsHotel.id_other_service.wifi_costs }} {{ PaxsHotel.currency_code }}, Per:
                  {{ PaxsHotel.id_other_service.per }}</span
                >
              </strong>
            </div>
            <div class="voucher-info">
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_38 || 'Valid for' }}:
              <span
                v-if="PaxsHotel.group_passengers"
                v-html="
                  replaceStr(
                    lang['hotel_mobile_new'].SFS_LANG_ROW_39,
                    ['<number_person>'],
                    [PaxsHotel.group_passengers.length + 1]
                  )
                "
              ></span
              ><br />
              <span
                v-if="PaxsHotel.room_type"
                v-html="
                  replaceStr(
                    lang['hotel_mobile_new'].SFS_LANG_ROW_40,
                    ['<room_type>'],
                    [roomType[PaxsHotel.room_type] ? roomType[PaxsHotel.room_type] : 'other']
                  )
                "
              ></span>
            </div>
            <div v-if="PaxsHotel.mealplan_desc">- {{ PaxsHotel.mealplan_desc }}</div>
            <div v-else class="voucher-info">
              <span v-if="Number(PaxsHotel.price_breakfast) && Number(PaxsHotel.hasBreakfast)">
                <span v-if="Number(PaxsHotel.bf_service_hour) === 1">
                  {{ lang['hotel_mobile_new'].SFS_LANG_ROW_63 }}
                </span>
                <span
                  v-else-if="Number(PaxsHotel.bf_service_hour) === 2"
                  v-html="
                    replaceStr(
                      lang['hotel_mobile_new'].SFS_LANG_ROW_46,
                      ['<breakfast_open_time>', '<breakfast_close_time>'],
                      [PaxsHotel.bf_opentime, PaxsHotel.bf_closetime]
                    )
                  "
                >
                </span>
                <br />
              </span>
              <span v-if="Number(PaxsHotel.price_lunch) && Number(PaxsHotel.hasLunch)">
                <span v-if="Number(PaxsHotel.lunch_service_hour) === 1">
                  {{ lang['hotel_mobile_new'].SFS_LANG_ROW_64 }}
                </span>
                <span
                  v-else-if="Number(PaxsHotel.lunch_service_hour) === 2"
                  v-html="
                    replaceStr(
                      lang['hotel_mobile_new'].SFS_LANG_ROW_48,
                      ['<lunch_open_time>', '<lunch_close_time>'],
                      [PaxsHotel.lunch_opentime, PaxsHotel.lunch_closetime]
                    )
                  "
                >
                </span>
                <br />
              </span>
              <span v-if="Number(PaxsHotel.price_mealplan) && Number(PaxsHotel.hasDinner)">
                <span v-if="Number(PaxsHotel.stop_selling_time) === 24">
                  {{ lang['hotel_mobile_new'].SFS_LANG_ROW_50 }}
                </span>
                <span v-else-if="PaxsHotel.stop_selling_time">
                  {{ lang['hotel_mobile_new'].SFS_LANG_ROW_65 }} {{ PaxsHotel.stop_selling_time }}
                </span>
                <br />
              </span>
            </div>
            <p
              v-html="
                replaceStr(
                  lang['hotel_mobile_new'].SFS_LANG_ROW_41,
                  ['<start_date>', '<end_date>'],
                  [moment(pax.flight_date).format('DD'), moment(moment(PaxsHotel.blockdate)).add(1, 'd').format('DD-MM-YYYY')]
                )
              "
            ></p>
            <p v-if="PaxsHotel.comment !== ''">
              <strong> {{ lang['hotel_mobile_new'].SFS_LANG_ROW_54 }}: </strong>
              <span class="hotel-comment" v-html="linkify(PaxsHotel.comment)"></span>
            </p>
            <p>
              {{ lang['hotel_mobile_new'].SFS_LANG_ROW_50 }}:
              <strong>{{ PaxsHotel.code }}</strong>
            </p>
            <h2 class="billing-title">{{ lang['hotel_mobile_new'].SFS_LANG_ROW_57 }}:</h2>
            <div class="voucher-info">
              <p>
                {{ lang['hotel_mobile_new'].SFS_LANG_ROW_58 }}:
                <span>{{ pax.flight_number }}</span>
              </p>
              <p>
                {{ lang['hotel_mobile_new'].SFS_LANG_ROW_59 }}:
                <span>{{ moment(pax.flight_date).format('DD-MMM-YYYY') }}</span>
              </p>
              <p>
                {{ lang['hotel_mobile_new'].SFS_LANG_ROW_8 }}:
                <span>{{ PaxsHotel.blockcode }}</span>
              </p>
              <p>
                {{ lang['hotel_mobile_new'].SFS_LANG_ROW_7 }}:
                <span>{{ PaxsHotel.code }}</span>
              </p>
              <p
                v-if="PaxsHotel.group_passengers"
                v-html="
                  replaceStr(
                    lang['hotel_mobile_new'].SFS_LANG_ROW_60,
                    ['<number_person>'],
                    [PaxsHotel.group_passengers.length + 1]
                  )
                "
              ></p>
            </div>
          </div>
        </div>
      </div>
      <!--Hotel voucher-->

      <!--Bus voucher-->
      <div v-if="hasIssued.bus && Bus && lang[3]" class="block-item">
        <div class="container">
          <h3 style="padding: 10pt 0; font-size: 16pt" class="title">{{ lang[3].SFS_LANG_ROW_1 }}</h3>
        </div>
      </div>
      <div v-if="hasIssued.bus && Bus && lang[3]" class="container">
        <div class="voucher">
          <div class="row" style="margin-top: 14pt">
            <div class="col-12">
              <p>{{ lang[3].SFS_LANG_ROW_2 }}</p>
              <p
                v-html="
                  replaceStr(lang[3].SFS_LANG_ROW_3, ['<airline_name>', '<drop_off_location>'], [airline.name, Bus.to_address])
                "
              ></p>
              <p>{{ lang[3].SFS_LANG_ROW_4 }}</p>
              <p>{{ lang[3].SFS_LANG_ROW_5 }}: {{ moment(Bus.date_expire_time).format('DD-MM-YYYY, HH:mm') }}</p>
              <p>{{ lang[3].SFS_LANG_ROW_6 }}: {{ Bus.at_address }}</p>
              <p>{{ lang[3].SFS_LANG_ROW_7 }}:</p>
              <p>{{ lang[3].SFS_LANG_ROW_8 }}: {{ Bus.bus_company_name }}</p>
              <p
                class="last"
                v-html="replaceStr(lang[3].SFS_LANG_ROW_9, ['<airline_name>', '<airline_name>'], [airline.name, airline.name])"
              ></p>
            </div>
          </div>
        </div>
      </div>
      <!--Bus voucher-->

      <!--Rental car voucher-->
      <div v-if="hasIssued.rentalCar && RentalCar && lang[6]" class="block-item">
        <div class="container">
          <h3 style="padding: 10pt 0; font-size: 16pt" class="title">{{ lang[6].SFS_LANG_ROW_1 }}</h3>
        </div>
      </div>
      <div v-if="hasIssued.rentalCar && RentalCar && lang[6]" class="container">
        <div class="voucher">
          <div class="row" style="margin-top: 14pt">
            <div class="col-12 text-center">
              <img :src="RentalCar.pickUp.logo" />
            </div>
            <div class="col-12">
              <p v-html="replaceStr(lang[6].SFS_LANG_ROW_13, ['<rental_company_name>'], [RentalCar.pickUp.company])">></p>
              <p>
                {{ lang[6].SFS_LANG_ROW_14 }}:
                <span>{{ RentalCar.pickUp.locationname }}</span>
              </p>
              <p>
                {{ lang[6].SFS_LANG_ROW_16 }}:
                <span> {{ RentalCar.pickUp.address }}</span>
              </p>
              <p>
                {{ lang[6].SFS_LANG_ROW_15 }}:
                <span>{{ RentalCar.dropOff.locationname }}</span>
              </p>
              <p>
                {{ lang[6].SFS_LANG_ROW_16 }}:
                <span>{{ RentalCar.dropOff.address }}</span>
              </p>
            </div>
          </div>
          <div style="margin-top: 20px">
            <p>
              <strong>{{ lang[6].SFS_LANG_ROW_17 }}:</strong>
            </p>
            <p v-html="replaceStr(lang[6].SFS_LANG_ROW_18, ['<rental_company_name>'], [RentalCar.pickUp.company])"></p>
          </div>
          <div style="margin-top: 20px">
            <p>
              <strong>{{ lang[6].SFS_LANG_ROW_19 }}:</strong>
            </p>
            <p>{{ lang[6].SFS_LANG_ROW_20 }}</p>
          </div>
        </div>
      </div>
      <!--Rental car voucher-->

      <!--Train voucher-->
      <div v-if="hasIssued.train && Train && lang[5]" class="block-item">
        <div class="container">
          <h3 style="padding: 10pt 0; font-size: 16pt" class="title">{{ lang[5].SFS_LANG_ROW_1 }}</h3>
        </div>
      </div>
      <div v-if="hasIssued.train && Train && lang[5]" class="container">
        <div class="voucher">
          <div class="row">
            <div class="col-3" style="margin-top: 14pt">
              <img src="@/assets/images/trains-logo.jpg" height="70" width="100" />
            </div>
            <div class="train-voucher-info col-9">
              <p class="font-weight-bold">
                {{ lang[5].SFS_LANG_ROW_2 }}
                <span>{{ pax.first_name }} {{ pax.last_name }}</span>
              </p>
            </div>
            <div class="col-12" style="margin: 14pt 0">
              <p>
                {{ lang[5].SFS_LANG_ROW_3 }}:
                <span>{{ Train.stationname_from }}</span>
              </p>
              <p>
                {{ lang[5].SFS_LANG_ROW_4 }}:
                <span>{{ Train.stationname_to }}</span>
              </p>
              <p>
                {{ lang[5].SFS_LANG_ROW_5 }}:
                <span>{{ Train.train_travel_date }}</span>
              </p>
              <p>
                {{ lang[5].SFS_LANG_ROW_6 }}
              </p>
            </div>
          </div>
          <div class="text-center">
            {{ lang[5].SFS_LANG_ROW_11 }}
          </div>
          <div class="train-voucher-info">
            <p>
              <strong>{{ lang[5].SFS_LANG_ROW_7 }}</strong
              ><br />
              <i>{{ lang[5].SFS_LANG_ROW_8 }}</i>
            </p>
          </div>
          <div class="train-voucher-info">
            <p>
              <strong>{{ lang[5].SFS_LANG_ROW_9 }}</strong
              ><br />
              <i>{{ lang[5].SFS_LANG_ROW_10 }}</i>
            </p>
          </div>
        </div>
      </div>
      <!--Train voucher-->
    </div>
  </div>
</template>

<script>
import CreditCard from '@/components/CreditCard/index'
import '@/assets/scss/modules/DownloadAllVoucher.scss'
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import html2canvas from 'html2canvas'
import { linkify } from '@/utils/helper'

export default {
  name: 'DownloadAllVoucher',
  components: { CreditCard },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      amountIssuedServices: 0,
      amountHasData: 0,
      taxi: {},
      hasIssued: {
        hotel: false,
        refreshment: false,
        bus: false,
        taxi: false,
        train: false,
        rentalCar: false
      },
      roomType: ['other', 'single', 'double', 'triple', 'quad']
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services',
      Refreshment: 'Refreshment/Refreshment',
      Bus: 'Bus/Bus',
      RentalCar: 'RentalCar/RentalCar',
      Train: 'Train/Train',
      PaxsHotel: 'SelectRoom/PaxsHotel'
    })
  },
  watch: {
    PaxsGroup: function () {
      this.$store.dispatch('SelectRoom/getVoucherHotel', { passenger_id: _.map(this.PaxsGroup, 'passenger_id') })
    },
    Services: function (services) {
      let self = this
      _.each(services, function (o) {
        if (o.service_id == 1 && o.service_status == 1) {
          self.hasIssued.hotel = true
          self.amountIssuedServices++
        } else if (o.service_id == 2 && o.service_status == 1) {
          self.hasIssued.refreshment = true
          self.amountIssuedServices++
        } else if (o.service_id == 3 && o.service_status == 1) {
          self.hasIssued.bus = true
          self.amountIssuedServices++
        } else if (o.service_id == 4 && o.service_status == 1) {
          self.hasIssued.taxi = true
          self.amountIssuedServices++
        } else if (o.service_id == 5 && o.service_status == 1) {
          self.hasIssued.train = true
          self.amountIssuedServices++
        } else if (o.service_id == 6 && o.service_status == 1) {
          self.hasIssued.rentalCar = true
          self.amountIssuedServices++
        }
      })
    },
    Refreshment: function (refreshment) {
      if (!_.isUndefined(refreshment)) {
        this.amountHasData++
      }
    },
    Bus: function (bus) {
      if (!_.isUndefined(bus)) {
        this.amountHasData++
      }
    },
    RentalCar: function (rentalCar) {
      if (!_.isUndefined(rentalCar)) {
        this.amountHasData++
      }
    },
    Train: function (train) {
      if (!_.isUndefined(train)) {
        this.amountHasData++
      }
    },
    PaxsHotel: function (hotel) {
      if (!_.isUndefined(hotel) && !_.isEmpty(hotel)) {
        if (this.hasIssued.taxi) {
          this.taxi = hotel
          if (hotel.length > 1) {
            this.taxi = _.first(hotel)
          }
          this.amountHasData++
        }
        this.amountHasData++
      } else {
        this.$store.dispatch('SelectRoom/getPaxsHotel')
      }
    }
  },
  mounted() {
    this.$store.dispatch('Home/getServices')
    this.$store.dispatch('Refreshment/getRefreshment')
    this.$store.dispatch('Bus/getBus')
    this.$store.dispatch('RentalCar/getRentalCar')
    this.$store.dispatch('Train/getTrain')
  },
  updated() {
    // We wait for vue rerender template then we download voucher
    this.checkDownloadVoucher()
  },
  methods: {
    replaceStr,
    capture: function () {
      html2canvas(document.querySelector('#app'), {
        useCORS: true,
        logging: false,
        x: 0,
        y: 0
      }).then((canvas) => {
        let dataUrl = canvas.toDataURL('image/png')
        let img = document.createElement('IMG')
        img.setAttribute('src', dataUrl)
        document.body.appendChild(img)
        let el = document.getElementById('app')
        // el.remove();
        let a = document.createElement('a')
        a.href = dataUrl
        a.download = 'all_vouchers.png'
        document.body.appendChild(a)
        // a.appendChild(img);
        a.click()
      })
    },
    checkDownloadVoucher: function () {
      if (this.amountHasData == this.amountIssuedServices) {
        this.capture()
      }
    },
    linkify
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  img {
    max-width: 100% !important;
  }
}

.hotel-comment ::v-deep a {
  font-size: inherit;
  color: var(--text-color);
  text-decoration: underline;
}
</style>
